module.exports = __webpack_public_path__ + "img/sternquell.29e8e907.png";